module.exports = __webpack_public_path__ + "static/media/viking_bow.9d333918.png";